import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CriticalIcon } from '@paypalcorp/pp-react-icons';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme';
import { trackErrorIM } from '../../fpti/fpti';

const { sysColorUnselectedContrast } = PAYPAL_THEME;

const STYLES = {
  error: {
    color: sysColorUnselectedContrast,
    fontSize: '13px',
  },
  criticalIcon: {
    color: '#D20000',
    position: 'relative',
    fontSize: 'unset',
    marginRight: '5px',
  },
};

/**
 * Component for displaying amount validation error message
 */
class AmountValidationError extends Component {
  componentDidMount() {
    const { errorSourceField, errorString, errorCode } = this.props;

    trackErrorIM({
      errorCode: errorCode || 'DONATION_AMOUNT_VALIDATION_ERROR',
      errorMessage: errorString,
      fieldName: errorSourceField,
    });
  }
  render() {
    const { errorString } = this.props;

    if (!errorString) {
      return null;
    }

    return (
      <span>
        <CriticalIcon size="xs" style={{ ...STYLES.criticalIcon }} />
        <span
          role="alert"
          style={STYLES.error}
          data-testid="amount-validation-error"
        >
          {errorString}
        </span>
      </span>
    );
  }
}

AmountValidationError.propTypes = {
  errorString: PropTypes.string,
  errorSourceField: PropTypes.string,
  errorCode: PropTypes.string,
  donationAmount: PropTypes.string,
};

export default AmountValidationError;
